const getS3ObjectFromURL = src => {
  const url = new URL(src);
  let s3Object = url.pathname.replace(/^\//g, ''); // remove initial slash from pathname
  return decodeURIComponent(s3Object);
};

export default getS3ObjectFromURL;
